export default "__VITE_ASSET__C12p$F0q__"